export enum MessagePayloadOption {
  faq = 'faq',
  form = 'form',
  media = 'media',
  file = 'file',
  schedulerData = 'schedulerData',
  input = 'input',
  docusign = 'docusign',
  emrSync = 'emrSync',
  quickReply = 'quickReply',
  carousel = 'carousel',
  signOff = 'signOff',
  command = 'command',
}
